module.exports = __webpack_public_path__ + "static/img/ai-img.8385384a.png";